import React from 'react';
import { CheckIcon } from '@heroicons/react/solid';
import { mapCIDisplayTitle } from '../../../../utils/clinicalInterviewWorkflow';

export default function CISideNavbar({ sections, currentSectionIndex, navigateToSection, isNavigating = false, wf }) {
  return (
    <div className="w-72 shrink-0 ml-8 mt-8 h-full p-5 bg-gray-50 rounded-2xl border border-gray-200 flex-col justify-start items-start gap-4 flex sticky top-8">
      <div className="self-stretch text-gray-500 text-sm font-bold leading-tight">Stages</div>
      <div className={`text-left self-stretch flex-col justify-start items-start gap-1 flex overflow-y-auto ${isNavigating ? 'opacity-60 pointer-events-none' : ''}`}>
        {sections.map((section, index) => {
          const isActive = currentSectionIndex === index;
          const isCompleted = section.status === "completed";
          return (
            <div
              key={index}
              className={`self-stretch h-9 px-3 py-2 ${isActive ? 'font-bold text-gray-900 border-l-2 border-violet-500' : ''} ${isCompleted ? 'bg-emerald-50' : ''} justify-start items-center gap-2 flex ${isNavigating ? 'cursor-not-allowed' : 'cursor-pointer'}`}
              onClick={() => !isNavigating && navigateToSection(index)}
            >
              <div
                className={`grow shrink basis-0 truncate ${isActive ? 'text-gray-900' : 'text-gray-500'} text-sm font-medium leading-tight`}
                title={mapCIDisplayTitle(section.sectionTitle, wf)}
              >
                {mapCIDisplayTitle(section.sectionTitle, wf)}
              </div>
              {isCompleted && (
                <CheckIcon className="w-4 h-4 text-green-500" aria-hidden="true" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}